import { render } from "./SelfHelp.vue?vue&type=template&id=0a3b3446&scoped=true"
import script from "./SelfHelp.vue?vue&type=script&lang=js"
export * from "./SelfHelp.vue?vue&type=script&lang=js"

import "./SelfHelp.vue?vue&type=style&index=0&id=0a3b3446&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3b3446"]])

export default __exports__